import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./navButton.css";

export interface Props extends React.PropsWithChildren<{}> {
  isActive: boolean;
  linkTo: string;
  isGroupStyle?: boolean;
}

export const NavButton = ({ isActive, linkTo, isGroupStyle, children }: Props) => {
  return (
    <Link
      to={linkTo}
      className={classNames(styles["nav-button"], {
        [styles.active]: isActive && !isGroupStyle,
        [styles["active-group"]]: isActive && isGroupStyle
      })}
    >
      {children}
    </Link>
  );
};
